module.exports = __webpack_public_path__ + "static/media/testimonial_agustina_betsy.2010cbae.png";